import script from "./Video.vue?vue&type=script&setup=true&lang=ts"
export * from "./Video.vue?vue&type=script&setup=true&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=09ccf639&lang=css"

const __exports__ = script;

export default __exports__